import React from 'react';
import Header from './Header';
import Footer from './Footer';
import LiveChat from './LiveChat';
import MaintenanceBar from '../components/MaintenanceBar';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="app-layout">
      <MaintenanceBar />
      <Header />
      <main className="app-main">
        {children}
      </main>
      <Footer />
      <LiveChat />
    </div>
  );
};

export default Layout;